import React from 'react';
import Loading from 'flow/components/ui-components/Loading';
import useAppContext from 'flow/hooks/useAppContext';
import useCountdown from 'flow/hooks/useCountdown';

interface Props {
    onTimeout: () => void;
}

const UaePassWaitingState: React.FC<Props> = ({ onTimeout }) => {
    const { i18next } = useAppContext();
    useCountdown(120, onTimeout);

    return (
        <output className="flex flex-col items-center gap-6 text-center">
            <h2 className="text-xl font-bold tracking-tight">
                {i18next.t(
                    'uaepass.waiting.title',
                    'You are now getting authenticated via UAE PASS',
                )}
            </h2>

            <Loading size={44} disableTimeout={true} />
        </output>
    );
};

export default UaePassWaitingState;
